import { ReactElement } from 'react';
import { Nullable } from '../../../../../../models';
import * as S from './emailLoginSuggestion.styled';
import { authorizationService } from '../../../../../authorization';
import { EmailLoginSuggestionModel } from './emailLoginSuggestion.model';

export const EmailLoginSuggestion = ({
  value,
}: EmailLoginSuggestionModel): Nullable<ReactElement> => (
  <S.EmailLoginSuggestion>
    <S.EmailLoginSuggestionValue
      href={authorizationService.getLoginLink(false, undefined, value)}
    >
      Войдите
    </S.EmailLoginSuggestionValue>{' '}
    или зарегистрируйтесь с использованием новой почты
  </S.EmailLoginSuggestion>
);
